export default __webpack_public_path__ + "static/media/selecta_main_mobile_small.fdf3b7ad.jpg";